<div class="modal-dialog modal-dialog-centered modal-xl">
  <div class="modal-content profile-modal">

    <div class="modal-header border-0">
      <div>
        <h5 class="modal-title">Meu Perfil</h5>
        <small class="text-muted">
          Visualize e edite suas informações de perfil
        </small>
      </div>
      <button type="button" class="btn-close" (click)="dialogRef.close()">
      </button>
    </div>

    <div class="modal-body mt-4">

      <div class="d-flex align-items-center gap-3 mb-4">
        <img [src]="previewImage || defaultImage" class="profile-avatar" alt="Foto do perfil" />

        <div *ngIf="usuario">
          <h6 class="mb-0">{{ nomeExibicao }}</h6>
          <small class="text-muted">{{ perfilNome }}</small><br />

          <span class="form-label mt-2 d-block">Foto (opcional)</span>

          <input
            #midiaInput
            id="midiaInput"
            hidden
            type="file"
            accept="image/*"
            (change)="onFileSelected($event)" />

          <div class="d-flex flex-wrap gap-2">
            <button type="button" class="btn btn-sm noticias-btn-editar" title="Selecionar e recortar a foto do perfil"
              (click)="midiaInput.click()">
              <i-lucide name="crop" size="16"></i-lucide>
              {{ previewImage ? 'Alterar foto' : 'Enviar foto' }}
            </button>

            <button type="button" class="btn btn-sm noticias-btn-excluir" *ngIf="previewImage" title="Remover a foto atual"
              (click)="removerFoto()">
              <i-lucide name="trash-2" size="16"></i-lucide>
              Remover
            </button>
          </div>
        </div>
      </div>

      <hr />

      <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
        <div class="row g-3">

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="user" size="14" color="#717182"></i-lucide>
              Nome Social
            </label>
            <input class="form-control" formControlName="nomeSocial" />
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="users" size="14" color="#717182"></i-lucide>
              Sexo
            </label>
            <select class="form-control" formControlName="sexoId">
              @for (item of sexos; track $index) {
              <option [value]="item.id">{{ item.nome }}</option>
              }
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="users" size="14" color="#717182"></i-lucide>
              Raça
            </label>
            <select class="form-control" formControlName="racaId">
              @for (item of racas; track $index) {
              <option [value]="item.id">{{ item.nome }}</option>
              }
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="flag" size="14" color="#717182"></i-lucide>
              Nacionalidade
            </label>
            <input class="form-control" formControlName="nacionalidade" />
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="map-pin" size="14" color="#717182"></i-lucide>
              Naturalidade
            </label>
            <input class="form-control" formControlName="naturalidade" />
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="phone" size="14" color="#717182"></i-lucide>
              Telefone
            </label>
            <input class="form-control" formControlName="telefone" mask="(00) 00000-0000" />
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="calendar" size="14" color="#717182"></i-lucide>
              Data de Nascimento
            </label>
            <input type="date" class="form-control" formControlName="dataNascimento" />
            <small class="text-danger" *ngIf="f['dataNascimento']?.hasError('required')">
              Data de nascimento é obrigatória
            </small>
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="briefcase" size="14" color="#717182"></i-lucide>
              Setor
            </label>
            <input class="form-control" formControlName="setor" />
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="id-card" size="14" color="#717182"></i-lucide>
              Cargo
            </label>
            <select class="form-control" formControlName="cargoId">
              @for (item of cargos; track $index) {
              <option [value]="item.id">{{ item.nome }}</option>
              }
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label">
              <i-lucide name="accessibility" size="14" color="#717182"></i-lucide>
              Necessidade Especial
            </label>
            <ng-select
              class="perfil-multi-select"
              formControlName="necessidadeEspeciaisIds"
              [items]="necessidadeEspecial"
              bindLabel="nome"
              bindValue="id"
              [multiple]="true"
              [closeOnSelect]="false"
              [clearSearchOnAdd]="true"
              placeholder="Selecione uma ou mais opções"
              notFoundText="Nenhuma opção encontrada"
              clearAllText="Limpar seleção"
              title="Selecionar necessidades especiais">
            </ng-select>
          </div>

          <div class="col-12" *ngIf="usuario">
            <div class="last-access">
              <i-lucide name="calendar" size="14" color="#060d18"></i-lucide>
              Último acesso:
              {{ usuario.ultimoLogin | date:'dd/MM/yyyy' }}
            </div>
          </div>

        </div>

        <div class="modal-footer border-0 mb-3">
          <button type="button" class="btn btn-cancelar-modal me-1" (click)="dialogRef.close()">
            Cancelar
          </button>
          <button type="submit" class="btn btn-warning text-white">
            Salvar Alterações
          </button>
        </div>

      </form>
    </div>
  </div>
</div>